<template>
  <div class="footer-box">
    <img src="@/assets/website/Logo.png" alt="" class="footer-box-logo"/>
    <div class="footer-box-info">
      <div>邮箱：zhaoyang@smfyun.com</div>
      <div>地址：武汉市洪山区雄楚大道260号和成中心1803</div>
      <div style="margin-top: 50px">
        Copyright 2024 武汉神码浮云科技有限公司 鄂ICP备15002606号-1
      </div>
    </div>
    <img src="@/assets/website/footer_code.jpg" alt="" class="footer-box-code" />

  </div>
</template>
<script>
export default {
  methods: {
    toAudio() {
      this.$router.push('/audio')
    },
    tolink(){
      // https://metastudio-api.cn-east-3.myhuaweicloud.com/icswebclient?robot_id=8a80803e8bcdb5a8018bea4924ab0120
      window.location.href = "https://metastudio-api.cn-east-3.myhuaweicloud.com/icswebclient?robot_id=8a80803e8bcdb5a8018bea4924ab0120"
    },
  }
}
</script>
<style scoped>
.footer-box {
  display: flex;
  justify-content: space-between;
  font-size: 20px;
  font-weight: 300;
  color: rgb(150, 131, 155);
  margin: 80px 0px;
}
.footer-box-info{
  width:800px;
}
.footer-box-logo {
  width: 256px;
  height: 93px;
  margin-right: 160px;
}
.footer-box-code{
  width:150px;
  height:150px;
  margin-right: 40px;
  opacity: 0;
}
</style>
